import { useState } from "react";
import { Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

export const TitleDialog = ({ q, onClose, onSave }) => {
  const [mode, setMode] = useState("ai");
  const [title, setTitle] = useState(q.title || "");
  const [desc, setDesc] = useState("");
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { await onSave(mode === "ai" ? { describe: desc } : { title }); } finally { setBusy(false); }
  };
  const tab = (k, label) => (
    <button data-testid={`title-mode-${k}`} onClick={() => setMode(k)} className={`flex-1 rounded-full px-3 py-1.5 text-xs font-semibold ${mode === k ? "bg-zinc-900 text-white" : "text-zinc-600"}`}>{label}</button>
  );
  return (
    <Dialog open onOpenChange={(o) => !o && !busy && onClose()}>
      <DialogContent data-testid="title-dialog" className="max-w-md">
        <DialogHeader><DialogTitle>Schimbă titlul postării</DialogTitle></DialogHeader>
        <div className="flex gap-1 rounded-full bg-zinc-100 p-1">{tab("ai", "Descriu, AI-ul îl scrie")}{tab("own", "Îl scriu eu")}</div>
        {mode === "ai"
          ? <Textarea data-testid="title-describe-input" value={desc} onChange={(e) => setDesc(e.target.value)} rows={3} placeholder="Ce ai vrea să transmită? ex. Black Friday la BRAGUS, reduceri până la 40% toată luna noiembrie" />
          : <Input data-testid="title-own-input" value={title} maxLength={120} onChange={(e) => setTitle(e.target.value)} placeholder="ex. Black Friday BRAGUS — până la -40%" />}
        <p className="text-[11px] text-zinc-500">Apoi „Alt text” scrie descrierea postării pornind de la titlu și de la imagine/creativ.</p>
        <button data-testid="title-save" onClick={save} disabled={busy || !(mode === "ai" ? desc.trim() : title.trim())} className="inline-flex items-center justify-center gap-2 rounded-full bg-amber-400 px-4 py-2 text-sm font-semibold text-zinc-950 disabled:opacity-50">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} {mode === "ai" ? "Generează titlul" : "Salvează titlul"}
        </button>
      </DialogContent>
    </Dialog>
  );
};
